import male from "../../assets/gender/male.png";
import female from "../../assets/gender/female.png";
import futanari from "../../assets/gender/futa.png";
//bodyshape
import buxom from "../../assets/body-type/buxom.png";
import chubby from "../../assets/body-type/chubby.png";
import medium from "../../assets/body-type/medium.png";
import muscular from "../../assets/body-type/muscular.png";
import petite from "../../assets/body-type/petite.png";
import small from "../../assets/body-type/small.png";

export default {
  gender: {
    male,
    female,
    futanari,
  },
  bodyShape: {
    buxom,
    chubby,
    medium,
    muscular,
    petite,
    small,
  },
};
